import { Component, Input, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { GroupingLogic } from '@r1-compass-library/models/criteria/grouping-logic.model';
import { InstructionsComponent } from '../instructions/instructions.component';
import { DividerComponent } from '../divider/divider.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { smartString } from '../../utilities/util-types';

export type GroupingLogicString = 'and' | 'or' | smartString;

export class GroupingLogicForm {
    type = new FormControl<'simple' | 'complex'>('simple', {
        validators: [Validators.required],
        nonNullable: true,
    });
    groupingLogic = new FormControl<string>('and', {
        validators: [Validators.required],
        nonNullable: true,
    });

    constructor(groupingLogic?: GroupingLogic) {
        this.type.setValue(groupingLogic?.type ?? 'simple');
        this.groupingLogic.setValue(groupingLogic?.groupingLogic ?? 'and');
    }
}

@Component({
    selector: 'r1-compass-lib-grouping-logic-complex',
    templateUrl: './grouping-logic-complex.component.html',
    styleUrl: './grouping-logic-complex.component.scss',
    imports: [
        CommonModule,
        MatButtonToggleModule,
        InstructionsComponent,
        FormsModule,
        ReactiveFormsModule,
        DividerComponent,
        MatFormFieldModule,
        MatInputModule,
    ],
})
export class GroupingLogicComplexComponent {
    @Input({ required: true })
    groupingLogicForm!: FormGroup<GroupingLogicForm>;

    readonly instructionText = input<string>();

    onLogicTypeToggleChange(value: 'simple' | 'complex') {
        if (value === 'simple') {
            this.groupingLogicForm.controls.groupingLogic.setValue('and');
        } else if (value === 'complex') {
            this.groupingLogicForm.controls.groupingLogic.setValue('');
        }
    }
}
